// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[dir=ltr] .value--WFvx1 {
  margin-left: 30px;
}[dir=rtl] .value--WFvx1 {
  margin-right: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/CorrelationLineChartTooltip/styles.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB,CAFA;EACE,kBAAiB;AACnB","sourcesContent":[".value {\n  margin-left: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"value": `value--WFvx1`
};
export default ___CSS_LOADER_EXPORT___;
